/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    useState,
    useEffect,
  } from 'react';

  import { useSelector, shallowEqual, useDispatch } from 'react-redux';
  import { Modal } from "react-bootstrap";
  import { useFormik } from 'formik';

  import RenderError from '../../../utils/RenderError'

  import {
    completeUserProfile,
  } from "app/services/auth";

  const EditProfile = ({isOpen, onClosed}) => {
    const { auth } = useSelector((state : any) => ({
      auth: state.auth,
    }), shallowEqual);
    const dispatch = useDispatch();

    const [open, setOpen] = useState<any>(false);
    const [errors, setErrors] = useState<any>([]);

    const close = () => {
      setOpen(false);

      onClosed && onClosed();
    }

    useEffect(() => {
      if (isOpen === true) {
        setOpen(true);
        setErrors([]);

        // Atualiza os valores do formik com os dados atuais do usuário
        formik.setValues({
          name: auth.user?.name || '',
          email: auth.user?.email || ''
        });
      } else {
        close();
      }
    }, [isOpen]);

    const formik = useFormik<any>({
      initialValues: {
        name: auth.user?.name || '',
        email: auth.user?.email || '',
      },
      onSubmit: (values) => {
        dispatch<any>(completeUserProfile(values.name, values.email, true)).then((response: any) => {
          close();
        })
        .catch(value => {
          setErrors(value);
        });
      },
    });

    return (
      <>
        <Modal
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={true}
          show={open}
          onHide={() => close()}
          dialogClassName="custom-modal mw-500px"
          className="bg-black bg-opacity-75"
        >
            <Modal.Header>
              <Modal.Title id="example-modal-sizes-title-lg" className="py-1 flex-root d-flex justify-content-center">
                <h2 className="fd-uppercase">Atualizar perfil</h2>
              </Modal.Title>

              <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => close()}>
                <span className="svg-icon svg-icon-1">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
                  </svg>
                </span>
              </div>
            </Modal.Header>

            <Modal.Body>
              <form
                className="mx-auto mw-450px w-100 pt-0 pb-10"
                id="edit-document-form"
                onSubmit={formik.handleSubmit}
              >
                <div className='d-flex flex-column fv-row'>
                  <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                    <span className='required'>Nome</span>
                  </label>

                  <input
                    type='text'
                    className='form-control form-control-solid-bg'
                    placeholder='Nome *'
                    autoComplete="name"
                    {...formik.getFieldProps('name')}
                    />

                  {errors && <RenderError error={errors['name']} />}

                  <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2 mt-4'>
                    <span className='required'>E-mail</span>
                  </label>

                  <input
                    type='email'
                    className='form-control form-control-solid-bg'
                    placeholder='E-mail *'
                    autoComplete="email"
                    {...formik.getFieldProps('email')}
                    />

                  {errors && <RenderError error={errors['email']} />}

                  <button
                    type='submit'
                    className='btn btn-lg btn-primary mt-5'
                    disabled={auth.actionLoading}
                  >
                    {!auth.actionLoading && <>
                      Atualizar
                    </>}
                    {auth.actionLoading && <span className="indicator-label">
                      Carregando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>}
                  </button>
                </div>
              </form>
            </Modal.Body>
        </Modal>
      </>
    )
  }

  export default EditProfile;
